import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { getOIDCToken } from '../../actions/auth'
import { useNavigate } from 'react-router-dom'

const Callback = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const { searchParams } = new URL(window.location.href)
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const redirect_uri = searchParams.get('redirect_uri');

    useEffect(() => {
        const payload = { code, navigate, state };
        if (redirect_uri) payload.redirect_uri = decodeURIComponent(redirect_uri);
        dispatch(getOIDCToken(payload))
    })
    return (
        <div>loading...</div>
    )
}

export default Callback;